module.exports = __webpack_public_path__ + "static/media/18ECA2.7450a9e5.jpg";